import produce from 'immer';
import { SET_CONFIG, SET_LIMIT, SET_LIMITS, TOGGLE_LOADING } from './actions';

export const defaultState = {
    limit: {},
    initialLimit: '',
    config: {
        enabled: false
    },
    isLoading: true,
    pendingLimits: [],
    amountToBeLeftOnBalance: {},
    initialAmountToBeLeftOnBalance: ''
};

export const reducer = (reducerSuffix) => produce((draftState, action) => {
    switch (action.type) {
        case SET_LIMITS:
        case SET_LIMITS + reducerSuffix: {
            const { limit, pendingLimits, amountToBeLeftOnBalance } = action.payload;

            Object.assign(draftState, {
                limit,
                pendingLimits,
                amountToBeLeftOnBalance,
                initialLimit: limit.amount,
                initialAmountToBeLeftOnBalance: amountToBeLeftOnBalance.amount
            });

            break;
        }

        case SET_CONFIG:
        case SET_CONFIG + reducerSuffix: {
            const { enabled, minWithdrawAmount, minLimitValue } = action.payload;

            Object.assign(draftState, {
                config: {
                    enabled,
                    ...minLimitValue && { minLimitValue: Number(minLimitValue) },
                    ...minWithdrawAmount && { minWithdrawAmount: Number(minWithdrawAmount) }
                }
            });

            break;
        }

        case SET_LIMIT:
        case SET_LIMIT + reducerSuffix: {
            const { name, value } = action.payload;

            Object.assign(draftState, {
                [name]: {
                    ...draftState[name],
                    amount: value
                }
            });

            break;
        }

        case TOGGLE_LOADING:
        case TOGGLE_LOADING + reducerSuffix: {
            Object.assign(draftState, {
                isLoading: action.payload
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
